module.exports = {
	light_off: {
		'primary': '#C4057C',
		'background': '#ECEFF1',
		'color': '#ECEFF1',
		'inverted': '#444444',
		'odd': '#ECEFF1',
		'even': '#f9fafa',
		'success': '#4CAF50',
		'info': '#0091EA',
		'warning': '#FF9800',
		'error': '#F44336',
		'hiventy_blue': '#002FA7',
		'hiventy_pink': '#C4057C',
		'hiventy_grey': '#7F7F7F',
		'red': '#F44336',
		'pink': '#E91E63',
		'purple': '#9C27B0',
		'deep-purple': '#673AB7',
		'indigo': '#3F51B5',
		'blue': '#2196F3',
		'light-blue': '#03A9F4',
		'cyan': '#00BCD4',
		'teal': '#009688',
		'green': '#4CAF50',
		'light-green': '#8BC34A',
		'lime': '#CDDC39',
		'yellow': '#FFEB3B',
		'amber': '#FFC107',
		'orange': '#FF9800',
		'deep-orange': '#FF5722',
		'brown': '#795548',
		'blue-grey': '#607D8B',
		'grey': '#9E9E9E',
		'xml_node': '#0288D1',
		'xml_attr': '#006064',
		'xml_val': '#6A1B9A',
		'xml_sep': '#78909C',
		'valgrad0': '#00FF00',
		'valgrad1': '#35FF00',
		'valgrad2': '#7CFF00',
		'valgrad3': '#9FFF00',
		'valgrad4': '#C2FF00',
		'valgrad5': '#FFF600',
		'valgrad6': '#FFD300',
		'valgrad7': '#FF8C00',
		'valgrad8': '#FF6900',
		'valgrad9': '#FF2300',
		'valgrad10': '#FF0000'
	},
	dark_off: {
		'primary': '#84FFFF',
		'background': '#34404b',
		'color': '#34404b',
		'inverted': '#FFF',
		'odd': '#34404b',
		'even': '#48535d',
		'success': '#00E676',
		'info': '#00B0FF',
		'warning': '#FFC400',
		'error': '#FF5252',
		'hiventy_blue': '#002FA7',
		'hiventy_pink': '#C4057C',
		'hiventy_grey': '#7F7F7F',
		'red': '#922820',
		'pink': '#8b123b',
		'purple': '#5d1769',
		'deep-purple': '#3d226d',
		'indigo': '#3F51B5',
		'blue': '#25306c',
		'light-blue': '#016592',
		'cyan': '#00707f',
		'teal': '#005a51',
		'green': '#2d6930',
		'light-green': '#53752c',
		'lime': '#7b8422',
		'yellow': '#998d23',
		'amber': '#997304',
		'orange': '#995b00',
		'deep-orange': '#993414',
		'brown': '#48332b',
		'blue-grey': '#394b53',
		'grey': '#5e5e5e',
		'xml_node': '#00B8D4',
		'xml_attr': '#00E5FF',
		'xml_val': '#18FFFF',
		'xml_sep': '#90A4AE'
	},
	light: {
		'primary': '#C4057C',
		'background': '#ECEFF1',
		'color': '#ECEFF1',
		'inverted': '#444444',
		'odd': '#ECEFF1',
		'even': '#f9fafa',
		'hiventy_blue': '#002FA7',
		'hiventy_pink': '#C4057C',
		'hiventy_grey': '#7F7F7F',
		'xml_node': '#0288D1',
		'xml_attr': '#006064',
		'xml_val': '#6A1B9A',
		'xml_sep': '#78909C',
		'success': '#4caf50',
		'info': '#2196f3',
		'warning': '#fb8c00',
		'error': '#ff5252',
		'red': '#F44336',
		'pink': '#E91E63',
		'purple': '#9C27B0',
		'deep-purple': '#673AB7',
		'indigo': '#3F51B5',
		'blue': '#2196F3',
		'light-blue': '#03A9F4',
		'cyan': '#00BCD4',
		'teal': '#009688',
		'green': '#4CAF50',
		'light-green': '#8BC34A',
		'lime': '#CDDC39',
		'yellow': '#FFEB3B',
		'amber': '#FFC107',
		'orange': '#FF9800',
		'deep-orange': '#FF5722',
		'brown': '#795548',
		'blue-grey': '#607D8B',
		'grey': '#9E9E9E',
		'valgrad0': '#00FF00',
		'valgrad1': '#35FF00',
		'valgrad2': '#7CFF00',
		'valgrad3': '#9FFF00',
		'valgrad4': '#C2FF00',
		'valgrad5': '#FFF600',
		'valgrad6': '#FFD300',
		'valgrad7': '#FF8C00',
		'valgrad8': '#FF6900',
		'valgrad9': '#FF2300',
		'valgrad10': '#FF0000',
		'valgradText0': '#000000',
		'valgradText1': '#000000',
		'valgradText2': '#111111',
		'valgradText3': '#111111',
		'valgradText4': '#222222',
		'valgradText5': '#333333',
		'valgradText6': '#555555',
		'valgradText7': '#EEEEEE',
		'valgradText8': '#EEEEEE',
		'valgradText9': '#FFFFFF',
		'valgradText10': '#FFFFFF'
	},
	dark: {
		'primary': '#84FFFF',
		'background': '#34404b',
		'color': '#34404b',
		'inverted': '#FFF',
		'odd': '#34404b',
		'even': '#48535d',
		'hiventy_blue': '#002FA7',
		'hiventy_pink': '#C4057C',
		'hiventy_grey': '#7F7F7F',
		'xml_node': '#00B8D4',
		'xml_attr': '#00E5FF',
		'xml_val': '#18FFFF',
		'xml_sep': '#90A4AE',
		'success': '#4caf50',
		'info': '#2196f3',
		'warning': '#fb8c00',
		'error': '#ff5252',
		'red': '#F44336',
		'pink': '#E91E63',
		'purple': '#9C27B0',
		'deep-purple': '#673AB7',
		'indigo': '#3F51B5',
		'blue': '#2196F3',
		'light-blue': '#03A9F4',
		'cyan': '#00BCD4',
		'teal': '#009688',
		'green': '#4CAF50',
		'light-green': '#8BC34A',
		'lime': '#CDDC39',
		'yellow': '#FFEB3B',
		'amber': '#FFC107',
		'orange': '#FF9800',
		'deep-orange': '#FF5722',
		'brown': '#795548',
		'blue-grey': '#607D8B',
		'grey': '#9E9E9E',
		'valgrad0': '#00FF00',
		'valgrad1': '#35FF00',
		'valgrad2': '#7CFF00',
		'valgrad3': '#9FFF00',
		'valgrad4': '#C2FF00',
		'valgrad5': '#FFF600',
		'valgrad6': '#FFD300',
		'valgrad7': '#FF8C00',
		'valgrad8': '#FF6900',
		'valgrad9': '#FF2300',
		'valgrad10': '#FF0000',
		'valgradText0': '#000000',
		'valgradText1': '#000000',
		'valgradText2': '#111111',
		'valgradText3': '#111111',
		'valgradText4': '#222222',
		'valgradText5': '#333333',
		'valgradText6': '#555555',
		'valgradText7': '#EEEEEE',
		'valgradText8': '#EEEEEE',
		'valgradText9': '#FFFFFF',
		'valgradText10': '#FFFFFF'
	},
	type: {
		AUTO: {
			color: '#2196F3',
			color_text: '#FFF'
		},
		MANUAL: {
			color: '#FFB300',
			color_text: '#FFF'
		},
		REQUEST: {
			color: '#673AB7',
			color_text: '#FFF'
		},
		PYTHON: {
			color: '#4CAF50',
			color_text: '#FFF'
		},
		UNKNOWN: {
			color: '#FFF',
			color_text: '#000'
		}
	},
	status: {
		CREATED: {
			color: '#666666',
			color_text: '#FFF'
		},
		WAITING: {
			color: '#FFB300',
			color_text: '#FFF'
		},
		PROCESSING: {
			color: '#2196F3',
			color_text: '#FFF'
		},
		DONE: {
			color: '#4CAF50',
			color_text: '#FFF'
		},
		ERROR: {
			color: '#F44336',
			color_text: '#FFF'
		},
		CANCELED: {
			color: '#8D6E63',
			color_text: '#FFF'
		},
		VALIDATING: {
			color: '#FFFF00',
			color_text: '#000'
		},
		SKIPPED: {
			color: '#333333',
			color_text: '#FFF'
		},
		RESETED: {
			color: '#999999',
			color_text: '#000'
		},
		STOPPED: {
			color: '#607D8B',
			color_text: '#FFF'
		},
		UNKNOWN: {
			color: '#FFF',
			color_text: '#000'
		}
	}
}



// WEBPACK FOOTER //
// ./src/App_colors.js